import {Agent} from './agent';

export class UserAccountType {
    accountType: number;
    accessType: number;
    isDefault: boolean;
    parentId: number;
    supplierId: number;
    agentId: number;
    agent: Agent;
    supplier: string;
}




// WEBPACK FOOTER //
// ./src/app/shared/api/model/user-account-type.ts